import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import { ProjectList } from '../common/ProjectList.js';
import { SmallProjectList } from '../common/SmallProjectList.js';
import { Pagination } from '../common/pagination.js';
import GiveWidgetToggle from '../common/GiveWidgetToggle.js';
import { FeatureShutOffMessage } from '../common/FeatureShutOffMessage.js';
import { EndOfListMessage } from '../common/EndOfListMessage.js';
import { choosePaginationProps } from './choosePaginationProps.js';

let ActiveProjects = function (props) {
    const data = props.data;
    const perPage = props.perPage || window.DC_DEFAULT_PER_PAGE;

    if (!data || parseInt(data.total) === -1) {
        return <FeatureShutOffMessage/>;
    }

    const showNextButton = data.proposals.length === perPage;

    if (data.proposals.length === 0) {
        return (
            <div className="tab-contents project-requests">
                <EndOfListMessage/>
            </div>
        );
    }

    const paginationProps = choosePaginationProps(!props.isPartnerPage || props.isMobile, data.totalProposals);

    const ProjectListComponent = props.isPartnerPage ? SmallProjectList : ProjectList;

    return (
        <div className="tab-contents project-requests">
            <ProjectListComponent projects={props.data.proposals} showGiveWidget={props.showGiveWidget}/>
            <Pagination
                showNextButton={showNextButton}
                page={props.page}
                perPage={props.perPage}
                simplePagination={paginationProps.simplePagination}
                max={paginationProps.max}
                changeURL={props.changeURL}
            />

            <ul className="search-controls">
                <li>
                    <GiveWidgetToggle on={props.showGiveWidget} toggle={props.toggleGiveWidget} />
                </li>
            </ul>
        </div>
    );
};

ActiveProjects.propTypes = {
    page: PropTypes.number.isRequired,
    changeURL: PropTypes.func.isRequired,
    toggleGiveWidget: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isPartnerPage: PropTypes.bool,
    showGiveWidget: PropTypes.bool,
    perPage: PropTypes.number,
    data: PropTypes.object,
};
ActiveProjects = memo(ActiveProjects);
export default ActiveProjects;
